import React, { Component } from 'react';
import { render } from '@testing-library/react';
import { Container, Image, Row, Col } from 'react-bootstrap';

class Imprint extends Component { 

    state = { displayImprint: false };

    toggleImprint = () => {
        this.setState({ displayImprint: !this.state.displayImprint })
    }

    render() {
        return (
            <Container className="text-center">
                <p>Angaben gem. § 5 TMG</p>
                <h4>Betreiber und Kontakt</h4>
                <p>Mike Keller<br />Unterriethstr. 22<br />65187 Wiesbaden</p>
                <p>Telefon: 0611 18172456<br />E-Mail: info(at)mkeller.net</p>

                <p>Der oben genannte Betreiber ist verantwortlich für die redaktionellen Inhalte (gem. § 55 II RstV).</p>
            </Container>
        );
    }
}

export default Imprint;
